import { render } from "./cnt-table_milestones.vue?vue&type=template&id=740c6a86&scoped=true"
const script = {}

import "./cnt-table_milestones.vue?vue&type=style&index=0&id=740c6a86&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740c6a86"]])

export default __exports__